import React from "react";

export default class Pill extends React.Component {
    static defaultProps = {
        filterable: true,
        className: ''
    };

    constructor(props){
        super(props);
        this.state = {
            focused: false
        };
    }

    onRemove = (event) => {
      if( this.props.onRemove ) this.props.onRemove();
    };

    onDeleteKey = () => {
        if( this.props.onRemove ) this.props.onRemove();
    };

    onClick = (event) => {
        if( this.props.onClick ) this.props.onClick();
    };

    onEnterKey = () => {
        if( this.props.onClick ) this.props.onClick();
    };

    onKeyUp = (event) => {
        if (!this.state.focused) return;
        if(event.key === 'Delete') this.onDeleteKey();
        if(event.key === 'Enter') this.onEnterKey();
    };

    render(){
        return(
          <div className="pill removable" tabIndex="0" onKeyUp={ this.onKeyUp } onFocus={ () => this.setState({focused: true}) } onBlur={ () => this.setState({focused: false}) } >
              <span className="pill--label" onClick={ this.onClick } >{ this.props.label }</span>
              { this.onRemove && <span className="pill--remove" onClick={ this.onRemove }> <i className="icn icn-close" /> </span> }
          </div>
        );
    }
}